const triggerSelector = "[data-modal-trigger]";
const targetSelector  = "[data-modal-target]";
const htmlActiveClass = "modal-active";
const elActiveClass   = "modal--active";

let els = null;

function Modal() {

	// Search for carousel elements on page
	els = document.querySelectorAll(triggerSelector);

	// If there are any, continue
	if (els.length) {
		init();
	}
}

const init = () => {

	// Add event listener on html element to listen for when modal triggers clicked
	document.documentElement.addEventListener("modal-trigger-clicked", function(e) {
		console.log(e);

		// Get target id
		const targetId = e.detail;
		
		// Check that corresponding target exists in document
		const targetEl = document.querySelector('[data-modal-target="' + targetId + '"]');

		// If no target found, abort
		if (targetEl === null) {
			return false;
		}

		// Add active class to html element (displays overlay)
		document.documentElement.classList.add(htmlActiveClass);
		
		// Add active class to target element
		targetEl.classList.add(elActiveClass);
	});

	// Loop through modal triggers
	[].forEach.call(els, function(item) {

		// Add click event listener
		item.addEventListener("click", function(e) {
			
			// Prevent normal behaviour
			e.preventDefault();
	
			// Get clicked element
			const clickedEl = e.target;
			
			// Create new custom event "modal-trigger-clicked", which also passed id of modal to target
			const modalTriggerClickedEvent = new CustomEvent("modal-trigger-clicked", {
				bubbles: true,
				detail: clickedEl.dataset.modalTrigger
			});
	
			// Dispatch custom event
			clickedEl.dispatchEvent(modalTriggerClickedEvent);
		})
	});

	// Initialise 'close' behaviours on modal elements
	[].forEach.call(document.querySelectorAll(targetSelector), function(item) {

		// Get close button inside modal
		const closeBtn = item.querySelector('[data-modal-close]');

		// If close button found
		if (closeBtn !== null) {

			// Add click event to close modal
			closeBtn.addEventListener("click", closeModal);
		}
	});
}

const closeModal = () => {
	// Remove active class from html element
	document.documentElement.classList.remove(htmlActiveClass);
		
	// Remove active class from all target elements
	[].forEach.call(document.querySelectorAll(targetSelector), function(item) {

		item.classList.remove(elActiveClass);

	});
}

export default Modal;